import { useSearchParams } from "react-router-dom";
import { MapPin, Phone, Linkedin, Mail } from "lucide-react";
import { Seo } from "../components/site/Seo";
import { MaskLines, Eyebrow, Reveal } from "../components/site/Motion";
import { EnquiryForm } from "../components/site/EnquiryForm";
import { SITE } from "../content/site";

const Detail = ({ icon: I, label, children, testId }) => (
  <div className="flex gap-4 border-b border-white/10 py-6" data-testid={testId}>
    <I className="mt-1 h-5 w-5 shrink-0 text-[#74DC26]" strokeWidth={1.5} />
    <div>
      <p className="eyebrow !text-[0.6rem] text-[#B4C7BA]">{label}</p>
      <div className="mt-2 text-lg text-[#F9F8F3]">{children}</div>
    </div>
  </div>
);

export default function ContactPage() {
  const [params] = useSearchParams();
  const interest = params.get("interest") ?? "";
  return (
    <>
      <Seo title="Contact Us" path="/contact" description="Contact Solitaire India in Mumbai to discuss your energy requirements, solar procurement options or partnership opportunities." />
      <section className="bg-[#F9F8F3] pt-32 pb-24 md:pt-40 md:pb-32" data-testid="contact-page">
        <div className="mx-auto grid max-w-[1440px] gap-14 px-5 md:px-10 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Eyebrow>Contact us</Eyebrow>
            <h1 className="font-display mt-6 text-4xl sm:text-5xl lg:text-6xl font-medium leading-[1.02] tracking-tight text-[#082619]">
              <MaskLines lines={["Let's discuss your", <span className="font-serif-i text-[#3f8a0f]">energy requirements.</span>]} />
            </h1>
            <Reveal delay={0.3}>
              <p className="mt-6 text-base md:text-lg leading-relaxed text-[#4C6053]">
                Tell us about your facility, consumption or partnership interest. A recent electricity bill helps us begin an initial assessment.
              </p>
              <div className="relative mt-10 overflow-hidden rounded-2xl bg-[#082619] px-6 py-2 md:px-8">
                <Detail icon={MapPin} label="Location" testId="contact-location">{SITE.location}</Detail>
                <Detail icon={Phone} label="Phone" testId="contact-phone">
                  <a href={SITE.phoneHref} className="link-underline">{SITE.phone}</a>
                </Detail>
                {SITE.email && (
                  <Detail icon={Mail} label="Email" testId="contact-email">
                    <a href={`mailto:${SITE.email}`} className="link-underline">{SITE.email}</a>
                  </Detail>
                )}
                <Detail icon={Linkedin} label="LinkedIn" testId="contact-linkedin">
                  <a href={SITE.linkedin} target="_blank" rel="noopener noreferrer" className="link-underline">Solitaire India on LinkedIn</a>
                </Detail>
              </div>
            </Reveal>
          </div>
          <Reveal className="lg:col-span-7 rounded-2xl border border-[#E5E1D3] bg-white p-6 md:p-12" delay={0.2}>
            <h2 className="font-display text-2xl md:text-3xl font-medium text-[#082619]">Enquiry form</h2>
            <p className="mt-2 mb-10 text-sm text-[#4C6053]">Fields marked * are required.</p>
            <EnquiryForm key={interest} defaultInterest={interest} />
          </Reveal>
        </div>
      </section>
    </>
  );
}
